import { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import { KeyValuePair } from "types";
import { indexesPages, searchIndexes } from "assets/constants";

export const isNotEmpty = (value: any) => {
  return value !== undefined && value !== null && value !== "";
};

export const getAllClassNames = (
  classNames: (string | undefined | boolean)[]
) => {
  let str = "";
  classNames.forEach((element) => {
    str += element ? element + " " : "";
  });
  return str;
};

export const isDev = () => {
  try {
    return process.env.NODE_ENV === "development";
  } catch {
    return false;
  }
};

export const setParams = (params?: KeyValuePair[]) => {
  if (!params) return "";
  let str = "";
  if (params) {
    for (const { key, value } of params) {
      if (isNotEmpty(value) && value != "0") {
        if (!Array.isArray(value)) {
          str += str ? `&${key}=${encodeURIComponent(value)}` : `${key}=${encodeURIComponent(value)}`;
        }
        else {
          str += str ? `&${value.map(value => `${key}=${value}`).join('&')}` : `${key}=${value.map(value => `${key}=${value}`).join('&')}&`;
        }
      }
    }
  }
  return str || ""; //str?.slice(0, -1) || "";
};

export const getHitTerm = (hit: any, term: string) => {
  const terms = term.split(".");
  return terms.length > 1 ? hit[terms[0]][terms[1]] : hit[term];
};

export const sortItemsLabels = (items: RefinementListItem[]) => {
  return items.sort((a, b) => {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  });
};


export const searchItemTerms = (item: any, terms: string[], query: string) => {
  return terms.some((term) => item[term].includes(query));
};

export const checkIfParamExist = (param: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has(param);
};

export const getParams = (paramsArr: string[]): string[] => {
  const urlParams = new URLSearchParams(window.location.search);
  const paramsValues: string[] = [];

  for (let i = 0; i < paramsArr.length; i++) {
    paramsValues.push(urlParams.get(paramsArr[i]) || "");
  }
  return paramsValues;
};

export const formatDate = (date: string) => {
  const dateObj = new Date(date);
  const dd = dateObj.getDate();
  const mm = dateObj.getMonth() + 1; // January is 0!
  const yyyy = dateObj.getFullYear();
  return `${dd}/${mm.toString().padStart(2, '0')}/${yyyy}`;
}

export const getDayOfWeek = (date: string) => {
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString('he-IL', { weekday: 'long' });
}

export const sanitizeString = (str: string) => {
  return str.replace(/<script>.*<\/script>/g, "").replace(/"/g, "").replace(/'/g, "");
}

export const getNameByKey = (key: string, globalSearchIndexes: KeyValuePair[]): string | null => {
  const indexItem = globalSearchIndexes.find(item => item.key === key);
  return indexItem ? (Array.isArray(indexItem.value) ? indexItem.value.join(',') : indexItem.value) : null;
}

export const getPageByObjectType = (objectType: string, hasMultiple: boolean = false): string => {
  if (hasMultiple) {
    const page = searchIndexes.find(item => item.objectType === objectType);
    return page ? page.url : '';
  } else {
    const page = indexesPages.find(item => item.objectType === objectType);
    return page ? page.url : '';
  }

}

export const getHebDayByCurentDay = (): string => {
  const hebrewDays = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'];
  // Get the current day index (0 for Sunday, 1 for Monday, etc.)
  const currentDayIndex = new Date().getDay();
  // Get the Hebrew initial for the current day
  const hebrewDay = hebrewDays[currentDayIndex];
  return hebrewDay;
}

export const isHebrewText = (text: string): boolean => {
  const hebrewRegex = /[\u0590-\u05FF]/;
  const englishRegex = /[A-Za-z]/;

  const hasHebrew = hebrewRegex.test(text);
  const hasEnglish = englishRegex.test(text);

  if (hasHebrew) return true;
  if (hasEnglish) return false;
  return false;
}



